import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ZoneImportModel } from 'src/app/models/imports/zone-import-model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ZoneService } from 'src/app/services/archive/zone.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-zone',
  templateUrl: './import-zone.component.html',
  styleUrls: ['./import-zone.component.scss'],
  standalone: false
})

export class ImportZoneComponent {

  errorZone: number = 0;
  eventFile: any;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  visibleTxt: boolean = false;
  zoneAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  zoneImport: boolean = false;

  constructor(
    private zoneService: ZoneService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }

  attachFileImport() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  downloadGuideImport() {
    this.zoneService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaZonas.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.zoneAlerts || this.zoneAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.zoneService.exportImportErrors(this.zoneAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionZonas_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  close() {
    const data: ModalObjectType = {};
    if (this.zoneImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  importZones() {
    this.zoneAlerts = [];
    this.errorZone = 0;
    this.visibleTxt = false;
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (!isPlatformBrowser(this.platformId)) return;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<ZoneImportModel>();
    let row: ZoneImportModel;
    let counter: number = 1, branchCode: number, name: string, sellerDocument: string, sellerName: string;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {
      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          'El archivo ingresado no tiene registros para importar.'
        );
        return;
      }
      rows.splice(0, 1);
      rows.forEach(element => {
        counter = counter + 1;
        let rowHasError = false;

        //A. Código Sucursal:
        branchCode = parseFloat(element[0] as string);
        if (isNaN(branchCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El código de la sucursal no es válido.`;
          this.zoneAlerts.push(alert);
          rowHasError = true;
        }

        //B. Nombre:
        name = element[1] as string;
        if (name == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El nombre de la zona no es válido.`;
          this.zoneAlerts.push(alert);
          rowHasError = true;
        } else if (name.length > 50) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El nombre de la zona supera el tamaño máximo de caracteres (50)`;
          this.zoneAlerts.push(alert);
          rowHasError = true;
        }

        //C. Documento Vendedor:
        sellerDocument = element[2] as string;
        if (sellerDocument == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El número de documento del vendedor no es válido.`;
          this.zoneAlerts.push(alert);
          rowHasError = true;
        } else if (sellerDocument.length > 15) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El número de documento del vendedor supera el tamaño máximo de caracteres (15)`;
          this.zoneAlerts.push(alert);
          rowHasError = true;
        }

        //D. Nombre Vendedor:
        sellerName = element[3] as string;
        if (sellerName != null) {
          if (sellerName.length > 75) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna D. El nombre del vendedor supera el tamaño máximo de caracteres (75)`;
            this.zoneAlerts.push(alert);
            rowHasError = true;
          }
        }

        if (!rowHasError) {
          row = new ZoneImportModel(counter, branchCode, name, sellerDocument, sellerName);
          rowsImports.push(row);
        } else {
          isOk = false;
        }
      });

      if (!isOk || rowsImports.length === 0) {
        this.errorZone = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
        return;
      }

      await this.processImportZones(rowsImports);
    });
  }

  async processImportZones(rowsImports: Array<ZoneImportModel>) {
    try {
      const response = await firstValueFrom(this.zoneService.importZones(rowsImports));
      this.loadPreInvoicingModel = response;
      this.zoneAlerts = response?.alerts ?? [];
      this.errorZone = response?.preInvoicingStateId;

      if (this.errorZone === 1) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea.',
          'ERROR'
        );
      } else if (this.zoneAlerts.length > 0) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con alertas, puede exportarlas si lo desea'
        );
      } else {
        this.visibleTxt = false;
        this.zoneImport = true;
        this.toastHandlerService.showToast(
          'success',
          `La importación terminó exitosamente.`
        );
        this.close();
      }
      this.clearInputFile();
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Zonas.', error);
    }
  }
}
